
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.212.788a2.69 2.69 0 00-3.803 0L16 12.197 4.59.787A2.69 2.69 0 10.789 4.592L12.197 16 .787 27.41a2.69 2.69 0 003.804 3.802L16 19.803l11.41 11.41a2.69 2.69 0 003.802-3.804L19.803 16l11.41-11.41a2.69 2.69 0 000-3.802z","fill":"currentColor"}})])
          )
        }
      }
    